import { OfferCard, OfferCardProps } from '@cash-rewards/cr-ui-components';
import { clsxm } from '@cash-rewards/reactjs';

import useGetUserAgent from '@/hooks/useGetUserAgent';

import { OfferAdModel } from '@/modules/shop/models/offerModels';

interface OfferCarouselCardProps {
  offer: OfferAdModel;
  className?: string;
  imageLoading?: OfferCardProps['imageLoading'];
}
const OfferCarouselAdCard: React.FC<OfferCarouselCardProps> = ({
  offer,
  className,
  ...rest
}: OfferCarouselCardProps) => {
  const { isMobile } = useGetUserAgent();

  const {
    id,
    adMobileImageUrl,
    brandNameInBold,
    adDesktopImageUrl,
    subCopy,
    highlightCopyInPurpleBold,
    adLink,
    adLabel,
    adImpressionUrl,
    isDynamic
  } = offer;

  const displayADLabel = shouldDisplayAdLabel(adLabel);

  return (
    <>
      {!isDynamic && (
        <OfferCard
          className={clsxm('w-[256px] ', className)}
          data-test-id={`offer-card-${id}`}
          imageUrl={isMobile ? adMobileImageUrl : adDesktopImageUrl}
          title={brandNameInBold}
          description={subCopy}
          commissionString={highlightCopyInPurpleBold}
          aspectRatio='1:1'
          href={`${adLink}`}
          isAdvert={displayADLabel}
          hideFavouriteIcon={true}
          imageHoverAnimation={false}
          cardImageAs='img'
          adImpressionUrl={adImpressionUrl}
          {...rest}
        ></OfferCard>
      )}

      {isDynamic === true && (
        <OfferCardForAd
          className={className}
          offer={offer}
          {...rest}
        ></OfferCardForAd>
      )}
    </>
  );
};

export default OfferCarouselAdCard;

const OfferCardForAd = ({
  offer,
  className,
  ...rest
}: OfferCarouselCardProps) => {
  const {
    id,
    adMobileImageUrl,
    brandNameInBold,
    adDesktopImageUrl,
    subCopy,
    highlightCopyInPurpleBold,
    adLink,
    adLabel,
    merchantName,
    merchantLogoUrl,
    merchantCommissionString,
    merchantLogoOverride,
    adImpressionUrl,
    singleTierEndDate
  } = offer;
  const { isMobile } = useGetUserAgent();
  const displayADLabel = shouldDisplayAdLabel(adLabel);
  return (
    <OfferCard
      className={clsxm('w-[256px] ', className)}
      data-test-id={`offer-card-${id}`}
      imageUrl={isMobile ? adMobileImageUrl : adDesktopImageUrl}
      title={brandNameInBold || merchantName}
      description={subCopy}
      commissionString={highlightCopyInPurpleBold || merchantCommissionString}
      aspectRatio='1:1'
      href={`${adLink}`}
      isAdvert={displayADLabel}
      hideFavouriteIcon={true}
      imageHoverAnimation={false}
      cardImageAs='img'
      adImpressionUrl={adImpressionUrl}
      logoUrl={merchantLogoOverride || merchantLogoUrl}
      singleTierEndDate={singleTierEndDate}
      {...rest}
    ></OfferCard>
  );
};

const shouldDisplayAdLabel = (adLabel: string): boolean => {
  return adLabel === 'Y';
};
